export class CollectionCard3D{

    constructor(data,store) {
        this.loader=new Three.TextureLoader();
        this.streamerImagePath=`/api/images/cards/streamer_images/${data["STID"]}/avatar.png`;
        this.cardFrontImagePath=`/api/images/cards/collections/${data["COID"]}/${data["cCMID"]}/${data.DEFAULT_IMAGE}`;
        this.cardBackImagePath=`/api/images/cards/collections/${data["COID"]}/back.png`;
        this.cardDecoratorImagePath=`/api/images/cards/collections/${data["COID"]}/${data["cCMID"]}/${data["DECORATOR_IMAGE"]}`;
        if(data.TYPE==="TEST"){
            this.cardFrontImagePath=`/api/images/cards/collections/sample_fg.png`;
            this.cardDecoratorImagePath=`/api/images/cards/collections/sample_decor.png`;
            this.cardBackImagePath=`/api/images/cards/collections/sample_bg.png`;
        }
        this.streamerImage=null;
        this.cardFrontImage=null;
        this.cardBackImage=null;
        this.cardNormalFrontImage=null;
        this.cardDecoratorImage=null;
        this.floatX=data.FLOAT_X;
        this.floatY=data.FLOAT_Y;
        this.shininess=data.SHININESS;
        this.specular=data.SPECULAR;
        this.store=store;
        this.loadFrontImage(this.cardFrontImagePath);
        this.loadStreamerImage(this.streamerImagePath);
        this.loadDecoratorImage(this.cardDecoratorImagePath);
        this.loadBackImage(this.cardBackImagePath);
        this.loadNormals(this.floatX,this.floatY);
        this.createFrontMaterial();
        this.createStreamerMaterial();
        this.createDecoratorMaterial();
        this.createBackMaterial();

    }
    loadNormals(floatX,floatY){
        let offsetX=3456*parseFloat(floatX);
        let offsetY=3206*parseFloat(floatY);
        //this.cardNormalFrontImage=this.loader.load(`/api/normal_map?x=${offsetX}&y=${offsetY}`);
        let canvas = document.getElementById("normalMapper");

        let ctx= canvas.getContext('2d');



        ctx.drawImage(this.store.state.MEDIA.NORMAL_MAP,
            offsetX, offsetY,   // Start at 70/20 pixels from the left and the top of the image (crop),
                640, 890,   // "Get" a `50 * 50` (w * h) area from the source image (crop),
                0, 0,     // Place the result at 0, 0 in the canvas,
                640, 890); // With as width / height: 100 * 100 (scale)
        //document.getElementById("app").appendChild(canvas);
        this.cardNormalFrontImage=this.loader.load(canvas.toDataURL());


    }

    loadFrontImage(imagePath){
        this.cardFrontImage=this.loader.load(imagePath,
            function(){
            },
            function(){
            },
            function(){
            });
    }
    loadStreamerImage(imagePath){
        let self=this;
        this.streamerImage=this.loader.load(imagePath,
            function(){
            },
            function(){
            },
            function(){
                self.loadStreamerImage("/api/images/cards/streamer_images/NO_IMAGE.png")
            });
    }
    loadDecoratorImage(imagePath){
        this.cardDecoratorImage=this.loader.load(imagePath);
    }

    loadBackImage(imagePath){
        this.cardBackImage=this.loader.load(imagePath);
    }




    createFrontMaterial(){
        this.frontMaterial = new Three.MeshPhongMaterial({map:this.cardFrontImage,transparent: true,shininess:25*this.shininess});

    }
    createStreamerMaterial(){
        this.streamerMaterial = new Three.MeshPhongMaterial({map:this.streamerImage,transparent: true,shininess:50*this.shininess});

    }
    createDecoratorMaterial(){
        this.decoratorMaterial = new Three.MeshPhongMaterial({map:this.cardDecoratorImage,transparent: true,shininess:100*this.shininess,specular:this.specular});
    }

    createBackMaterial(){
        this.backMaterial = new Three.MeshPhongMaterial({map:this.cardBackImage,transparent: true,shininess:25*this.shininess});
        this.backMaterial.side = Three.BackSide;
    }
    animateUse(){
        var video = document.createElement('video');

        var source = document.createElement('source');

        source.setAttribute('src', '/api/images/card_used_glitter.webm');

        video.appendChild(source);
        video.muted=true;
        video.play();

        const texture = new Three.VideoTexture(video);
        texture.minFilter = Three.LinearFilter;
        texture.magFilter = Three.LinearFilter;
        texture.format = Three.RGBAFormat;


        const geometry = new Three.BoxGeometry(6.4, 8.9,0.03);
        const materiala = new Three.MeshBasicMaterial({ map: texture});
        materiala.blending = Three.AdditiveBlending;
        materiala.transparent=true;
        //materiala.opacity=0.5;

        const plane = new Three.Mesh(geometry, materiala);
        plane.material.side = Three.DoubleSide;
        this.card.add(plane);



    }

    removeUse(){
        this.card.remove(this.card.children[this.card.children.length])
    }

    render(){
        this.geometry_front = new Three.PlaneBufferGeometry( 6.4, 8.9, 1, 1 );
        this.geometry_front_decorator = new Three.PlaneBufferGeometry( 6.4, 8.9, 1, 1 );

        this.geometry_side = new Three.BoxGeometry( 6.4, 8.9, 0.01 );
        this.material_side = new Three.MeshBasicMaterial( { color: 0x000000 } );
        this.cube_side = new Three.Mesh( this.geometry_side, this.material_side );

        this.geometry_front_image = new Three.PlaneBufferGeometry( 4.8, 3.35, 1, 1 );

        this.geometry_front.dynamic=true;
        this.geometry_front_decorator.dynamic=true;
        let geometry_back = new Three.PlaneBufferGeometry( 6.4, 8.9, 1, 1 );
        geometry_back.dynamic=true;


        this.backMaterial.normalMap=this.cardNormalFrontImage;
        this.backMaterial.normalScale=new Three.Vector2( 0, 0.5 );

        this.decoratorMaterial.normalMap=this.cardNormalFrontImage;
        this.decoratorMaterial.normalScale=new Three.Vector2( 0, 0.5 );

        this.frontMaterial.normalMap=this.cardNormalFrontImage;
        this.frontMaterial.normalScale=new Three.Vector2( 0, 0.5 );


        this.card = new Three.Object3D();
        this.card.buffersNeedUpdate = true;
        this.card.needsUpdate = true;

        this.geometry_front.clearGroups();
        this.geometry_front.addGroup( 0, Infinity, 0 );
        //this.geometry_front.addGroup( 0, Infinity, 1 );
        //geometry_back.applyMatrix( new Three.Matrix4().makeRotationY( Math.PI ) );
        let mesh1 = new Three.Mesh( this.geometry_front, this.frontMaterial );
        let mesh5 = new Three.Mesh( this.geometry_front_decorator, this.decoratorMaterial );

        let mesh2 = new Three.Mesh( geometry_back, this.backMaterial );
        mesh1.position.z+=0.010;
        mesh2.position.z-=0.010;
        this.mesh4 = new Three.Mesh( this.geometry_front_image, this.streamerMaterial);
        this.mesh4.position.z+=0.011;
        mesh5.position.z+=0.012;
        this.mesh4.position.y+=1.64;



        this.card.add( mesh1 );
        this.card.add( mesh2 );

        this.card.add( this.mesh4 );

        this.card.add( mesh5 );
        this.card.add( this.cube_side );

        return this.card
    }

}
import * as Three from 'three'

